/** Return-reason management. */
import { endpoints } from '@/config/env';
import type { ReturnReason, ReturnReasonInput } from '@/types';
import { request } from './client';

export function fetchReasons(signal?: AbortSignal): Promise<ReturnReason[] | null> {
  return request<ReturnReason[] | null>(endpoints.reasons(), { signal });
}

export function addReason(input: ReturnReasonInput): Promise<ReturnReason[] | ReturnReason | null> {
  return request<ReturnReason[] | ReturnReason | null>(endpoints.reasons(), {
    method: 'POST',
    body: input,
  });
}

export function updateReason(
  slug: string,
  input: Partial<ReturnReasonInput>,
): Promise<ReturnReason[] | ReturnReason | null> {
  return request<ReturnReason[] | ReturnReason | null>(endpoints.reason(slug), {
    method: 'PUT',
    body: input,
  });
}

export function deleteReason(slug: string): Promise<null> {
  return request<null>(endpoints.reason(slug), { method: 'DELETE' });
}

export function reorderReasons(orderedSlugs: string[]): Promise<unknown> {
  return request<unknown>(endpoints.reasonsReorder(), { method: 'PUT', body: orderedSlugs });
}
